export default "__VITE_ASSET__USFtIhqz__"